export const exportFile = (fileUrl, fileName) => {
  if (!fileUrl) return;

  const downloadLink = document.createElement('a');
  downloadLink.href = fileUrl;
  if (fileName) {
    downloadLink.download = fileName;
  }
  downloadLink.click();
  downloadLink.remove();
};
